import Input from 'antd/es/input';

const { Search } = Input;

export default Search;
